// Check if page is project page and remove transparent header
var projectPage = document.querySelector('.post-type-archive-project')

if(projectPage){
    projectPage.classList.remove('transparent-header');
}

// Check if page is search page and remove transparent header
var searchPage = document.querySelector('.search')

if(searchPage){
    searchPage.classList.remove('transparent-header');
}

// Check if page is newspage and remove transparent header
var newsPage = document.querySelector('.blog')

if(newsPage){
    newsPage.classList.remove('transparent-header');
}

// Check if page is single blog page
var newsPage = document.querySelector('.single-post')

if(newsPage){
    newsPage.classList.add('transparent-header');
}